module.exports = __webpack_public_path__ + "static/media/expandable_list.7c80f5f2.jpg";